module.exports = __webpack_public_path__ + "img/image8.e8847649.png";